import { useQuery } from '@tanstack/react-query';
import { useAppContext } from 'src/contexts/AppContext';
import { useClientLogContext } from 'src/contexts/ClientLogContext';
import { tryInvokeApi } from 'src/utils/tryExecuteUtils';
import { BulkEditListingClient, ListingQuery } from 'src/WebApiController';

export const useBulkUpdateListingBarcodesPreviewQuery = (
  filterQueryWithEventIds: ListingQuery
) => {
  const { activeAccountWebClientConfig } = useAppContext();
  const { trackError } = useClientLogContext();
  return useQuery({
    queryKey: [
      'BulkEditListingClient.bulkUpdateBarcodesPreview',
      activeAccountWebClientConfig.activeAccountId,
      filterQueryWithEventIds,
    ],
    queryFn: () => {
      if (activeAccountWebClientConfig.activeAccountId == null) {
        return null;
      }
      return tryInvokeApi(
        () => {
          return new BulkEditListingClient(
            activeAccountWebClientConfig
          ).bulkUpdateBarcodesPreview(filterQueryWithEventIds);
        },
        (error) => {
          trackError('BulkEditListingClient.bulkUpdateBarcodesPreview', error);
        }
      );
    },

    enabled: activeAccountWebClientConfig.activeAccountId != null,
    refetchOnWindowFocus: false,
  });
};
